module.exports = __webpack_public_path__ + "static/img/apply-two.2e3f4dc1.png";